import { Navigate, useLocation, useParams } from "react-router-dom";
import { useUserStore } from "../store/user.store";
import { AccountType } from "../constants/account-types.constants";
import { useEffect } from "react";

export const PrivateAdminRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { token, user } = useUserStore();
  const { pathname } = useLocation();

  if (!token || !user) {
    return <Navigate to="/auth/login" />;
  }
  switch (user.accountType) {
    case AccountType.ADMIN:
      return pathname.startsWith("/admin") ? (
        <>{children}</>
      ) : (
        <Navigate to="/auth/login" />
      );

    default:
      throw new Error("unknown account type");
  }
};

export const PrivateEphemeralRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { token, user } = useUserStore();
  const { campaignId } = useParams();
  const { pathname } = useLocation();

  console.log(token);

  if (!campaignId) {
    return <Navigate to="/auth/login" />;
  }

  if (!token || !user) {
    return <Navigate to={`/auth/login?campaign=${campaignId}`} />;
  }
  switch (user.accountType) {
    case AccountType.EPHEMERAL:
      return pathname.startsWith("/ephemeral") ? (
        <>{children}</>
      ) : (
        <Navigate to={`/auth/login?campaign=${campaignId}`} />
      );
    default:
      throw new Error("unknown account type");
  }
};

export const PrivateBrandRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { token, user, brands } = useUserStore();
  const { pathname } = useLocation();

  // Call connectSocket only once when component mounts
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!brands?.length) return;

  }, [user]);

  if (!token || !user) {
    return <Navigate to="/brands/auth/login" />;
  }

  switch (user.accountType) {
    case AccountType.BRAND:
      return pathname.startsWith("/brands") ? (
        user.name === null || user.name === "" ? (
          <Navigate to="/brands/auth/complete-profile" />
        ) : brands?.length ? (
          <>{children}</>
        ) : (
          <>
            {children}
            <Navigate to="/brands/workspace/join" />
          </>
        )
      ) : (
        <Navigate to="/brands/auth" />
      );
    default:
      throw new Error("unknown account type");
  }
};
